<template>
    <div v-loading="isLoading">
        <div v-if="deal">
            <div class="mt-3">
                <template v-for="t in document_templates">
                    <button class="btn btn-light mb-2 mr-2" @click="t.custom_variables ? prepareVariables(t.id) : generateDocument(t.id)">{{t.name}}</button>
                </template>
            </div>
        </div>
        <el-dialog v-if="document_template_state_form && document_template" :visible.sync="document_template_state_form" :title="document_template.name" :append-to-body="true" width="350px">
            <CustomVariablesForm :deal="deal" :document_template="document_template" @prepared="onPreparedCustomVariables"/>
        </el-dialog>
    </div>
</template>

<script>
import { saveAs } from 'file-saver';
import DocumentForm from "./DocumentForm";
import CustomVariablesForm from "../documents/CustomVariablesForm";
export default {
    name: "DocumentList",
    components: {CustomVariablesForm, DocumentForm},
    props: {
        deal_id: {
            type: Number,
            required: true,
        },
    },
    data: () => ({
        deal: null,
        form_state: false,
        form_name: null,

        document_templates: [],
        document_template: null,
        document_template_state_form: false,

        isLoading: false,
    }),
    mounted() {
        this.fetchDeal();
        this.fetchDocumentTemplates();
    },
    watch: {
        deal_id(val) {
            if (val) this.fetchDeal();
        }
    },
    methods: {
        fetchDeal() {
            let self = this;
            this.isLoading = true;
            axios.get('/api/deals/' + this.deal_id)
                .then(response => {
                    self.isLoading = false;
                    self.deal = response.data;
                })
                .catch((error) => {
                    self.isLoading = false;
                    self.deal = null;
                })
        },
        fetchDocumentTemplates(){
            let self = this;
            axios.get('/api/deals/' + this.deal_id + '/document_templates')
                .then(response => {
                    self.document_templates = response.data;
                });
        },
        showForm(name) {
            this.form_name = name;
            this.form_state = true;
        },
        downloadDocument(form_name) {
            let self = this;
            this.isLoading = true;
            axios({
                method: 'POST',
                url: '/api/documents/generate/deal/' + this.deal_id,
                data: {form_name: form_name},
                responseType: 'arraybuffer'
            })
                .then(response => {
                    self.isLoading = false;
                    saveAs(new Blob([response.data]), form_name + '.docx', {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});
                })
                .catch(e => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка',
                        duration: 2000,
                    });
                });
        },
        prepareVariables(id) {
            this.document_template = _.cloneDeep(_.find(this.document_templates, {id: id}));
            this.document_template_state_form = true;
        },
        onPreparedCustomVariables(event) {
            this.document_template = null;
            this.document_template_state_form = false;
            this.generateDocument(event.id, event.values);
        },
        generateDocument(id, custom_variables = {}) {
            let self = this;
            this.isLoading = true;
            let template = _.find(this.document_templates, {id: id})
            axios({
                method: 'POST',
                url: '/api/documents/generate/deal/' + this.deal_id,
                data: {
                    document_template_id: template.id,
                    custom_variables: custom_variables,
                },
                responseType: 'arraybuffer'
            })
                .then(response => {
                    self.isLoading = false;
                    saveAs(new Blob([response.data]), template.name + '.docx', {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});
                })
                .catch(e => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка',
                        duration: 2000,
                    });
                });
        }
    }
}
</script>

<style scoped>

</style>
